import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import {
  item,
  edit,
  listRoleType,
  listStatus,
  listActivationType
} from '../../../lib/api/user';
import { list as listClub } from '../../../lib/api/club';
import { list as listJudge } from '../../../lib/api/judge';
import { list as listSupervisor } from '../../../lib/api/supervisor';

export function Edit({ userId, onClose, onUpdate }) {
  const [role, setRole] = useState([]);
  const [status, setStatus] = useState([]);
  const [activationType, setActivationType] = useState([]);
  const [club, setClub] = useState([]);
  const [judges, setJudges] = useState([]);
  const [supervisors, setSupervisors] = useState([]);

  const [user, setUser] = useState({});
  const [errors, setErrors] = useState({});

  const [previewImage, setPreviewImage] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    (async () => {
      const resItem = await item({ user_guid: userId });
      const resRole = await listRoleType();
      const resStatus = await listStatus();
      const resActivationType = await listActivationType();
      const resClub = await listClub();
      const resJudge = await listJudge();
      const resSupervisor = await listSupervisor();

      setUser(resItem[0]);
      setPreviewImage(process.env.REACT_APP_BASE_API_URL +`/uploads/${resItem[0].document_guid}.jpg`);
      setRole(resRole);
      setStatus(resStatus);
      setActivationType(resActivationType);
      setClub(resClub);
      setJudges(resJudge);
      setSupervisors(resSupervisor);
    })();
  }, [userId]);

  const handelInput = e => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const handelDateChange = (date, name) => {
    setUser({ ...user, [name]: date });
  };

  const handleImageChange = e => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreviewImage(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const validateForm = () => {

    const isClub_entities = club_entities_id => {
      const privilegedRoles = ["admin", "operator"];
      if (!privilegedRoles.includes(user.role_type_id) && !['judge', 'supervisor'].includes(user.role_type_id)) {
        return Boolean(club_entities_id);
      }
      return true;
    };

    const newErrors = {
      role_type_id: !user.role_type_id,
      status_id: !user.status_id,
      name: !user.name,
      club_entities_id: !isClub_entities(user.club_entities_id),
      operator_entities_id: ['judge', 'supervisor'].includes(user.role_type_id) && !user.operator_entities_id,
      users_activation_type_id: !user.users_activation_type_id
    };

    console.log('user', user);
    console.log('newErrors', newErrors);
    
    setErrors(newErrors);
    console.log('Object.values(newErrors)',!Object.values(newErrors).some(Boolean));

    return !Object.values(newErrors).some(Boolean);
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!validateForm()) return;


    const formData = new FormData(event.currentTarget);
    //formData.append('descreption', '');

    await edit(Object.fromEntries(formData.entries()), userId);

    const _activation_type = activationType.find(opt => opt.users_activation_type_id === String(user.users_activation_type_id));
    onUpdate?.({...user, activation_type_name: _activation_type.name, document_guid: userId});
    onClose?.();
  };

  const isOperatorRole = ['judge', 'supervisor'].includes(user.role_type_id);
  const operatorLabel = user.role_type_id === 'judge' ? 'Sudija' : 'Delegat';
  const operatorRequiredLabel = user.role_type_id === 'judge' ? 'sudiju' : 'delegata';
  const operatorEmptyLabel = user.role_type_id === 'judge' ? 'sudija' : 'delegata';
  const operatorOptions = (user.role_type_id === 'judge' ? judges : supervisors).map(operator => ({
    value: String(operator.entities_id),
    label: `${operator.name} ${operator.last_name}${operator.place ? ` - ${operator.place}` : ''}`,
    fullName: `${operator.name} ${operator.last_name}`
  }));

  return (
      <Card>
        <Card.Header>
          <Row className={classNames('g-2')}>
            <Col>
              <Flex>
                <h5 className="mb-0">Izmjena podataka o korisniku</h5>
              </Flex>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit} encType="multipart/form-data" noValidate>
            <Row className="mb-3">
              <Col md="6">
                <Form.Label>Slika</Form.Label>
                <div
                    onClick={() => fileInputRef.current?.click()}
                    style={{
                      cursor: 'pointer',
                      width: 120,
                      height: 120,
                      borderRadius: '50%',
                      overflow: 'hidden',
                      border: '2px dashed #ccc',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                >
                  {previewImage ? (
                      <img
                          src={previewImage}
                          alt="Preview"
                          onError={(e) => {
                            e.target.onerror = null; // spreči loop ako fallback ne postoji
                            if (!e.target.dataset.fallbackTried) {
                              e.target.src = process.env.REACT_APP_BASE_API_URL +'/uploads/blank.jpg';
                              e.target.dataset.fallbackTried = 'true';
                            }
                          }}
                          style={{width: '100%', height: '100%', objectFit: 'cover'}}
                      />
                  ) : (
                      <span className="text-muted">Klikni za sliku</span>
                  )}
                </div>
                <Form.Control
                    type="file"
                    name="image"
                    accept="image/*"
                    style={{display: 'none'}}
                    ref={fileInputRef}
                    onChange={handleImageChange}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>Email</Form.Label>
                <Form.Control
                    name="email"
                    onChange={handelInput}
                    isInvalid={errors.email}
                    value={user.email || ''}
                    autoComplete="off"
                    disabled
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label>Password</Form.Label>
                <Form.Control
                    name="password"
                    onChange={handelInput}
                    isInvalid={errors.password}
                    value={user.password || ''}
                    autoComplete="off"
                    type="password"
                    disabled
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>Rola</Form.Label>
                <Form.Select
                    name="role_type_id"
                    onChange={handelInput}
                    isInvalid={errors.role_type_id}
                    value={user.role_type_id || ''}
                >
                  <option value="">Izaberite</option>
                  {role.map(f => (
                      <option key={f.role_type_id} value={f.role_type_id}>
                        {f.name}
                      </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <Form.Label>Status</Form.Label>
                <Form.Select
                    name="status_id"
                    value={user.status_id || ''}
                    onChange={handelInput}
                    isInvalid={errors.status_id}
                     >
                  {status.map(f => (
                          <option key={f.status_id} value={f.status_id}>
                            {f.name}
                          </option>
                      ))}
                </Form.Select>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>Ime i prezime</Form.Label>
                <Form.Control
                    name="name"
                    value={user.name || ''}
                    onChange={handelInput}
                    isInvalid={errors.name}
                    autoComplete="off"
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} md="6">
                <Form.Label>Potvrda</Form.Label>
                <Form.Select
                    name="users_activation_type_id"
                    value={user.users_activation_type_id || ''}
                    onChange={handelInput}
                    isInvalid={errors.users_activation_type_id}
                >
                  {activationType.map(p => (
                          <option
                              key={p.users_activation_type_id}
                              value={p.users_activation_type_id}
                          >
                            {p.name}
                          </option>
                      ))}
                </Form.Select>
              </Form.Group>
              {(user.role_type_id !== "admin" && user.role_type_id !== "operator" && user.role_type_id !== "") && (
              isOperatorRole ? (
              <Form.Group as={Col} md="6">
                <Form.Label>{operatorLabel}</Form.Label>
                <Select
                    name="operator_entities_id"
                    isClearable
                    placeholder={`Pretraži ${operatorLabel.toLowerCase()}...`}
                    noOptionsMessage={() => `Nema pronađenih ${operatorEmptyLabel}`}
                    options={operatorOptions}
                    value={operatorOptions.find(option => option.value === String(user.operator_entities_id)) || null}
                    onChange={option => setUser(currentUser => ({
                      ...currentUser,
                      operator_entities_id: option?.value || '',
                      name: option?.fullName || ''
                    }))}
                    className={errors.operator_entities_id ? 'is-invalid' : ''}
                />
                {errors.operator_entities_id && (
                    <div className="invalid-feedback d-block">Izaberite {operatorRequiredLabel}.</div>
                )}
              </Form.Group>
              ) : (
              <Form.Group as={Col} md="6">
                <Form.Label>Klub</Form.Label>
                <Form.Select
                    name="club_entities_id"
                    value={user.club_entities_id || ''}
                    onChange={handelInput}
                    isInvalid={errors.club_entities_id}
                >
                  <option value="">Izaberite</option>
                  {club.map(p => (
                      <option key={p.entities_id} value={p.entities_id}>
                        {p.name}
                      </option>
                  ))}
                </Form.Select>
              </Form.Group>
              )
              )}
            </Row>

            <Button type="submit" className="mt-3">Sačuvaj izmjene</Button>
          </Form>
        </Card.Body>
      </Card>
  );
}
